// Create a scheduled job.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import { useBreadcrumbs } from '@/client/hooks/use-breadcrumbs';
import { useHasPermission } from '@/client/hooks/useHasPermission';
import JobForm from './JobForm';
import { AccessDenied, PageShell, SCHEDULER_BASE } from './schedulerUi';

const SchedulerJobFormPage: React.FC = () => {
  useBreadcrumbs([
    { label: 'Scheduler', href: SCHEDULER_BASE },
    { label: 'Jobs', href: `${SCHEDULER_BASE}/jobs` },
    { label: 'New job' },
  ]);
  const navigate = useNavigate();
  const perm = useHasPermission('scheduler.manage');
  const allowed = perm.isSuperAdmin || perm.hasPermission;

  return (
    <PageShell title="New job" description="A job calls one HTTPS URL on a schedule.">
      {perm.isLoading ? (
        <Skeleton className="h-64 w-full" />
      ) : !allowed ? (
        <AccessDenied code="scheduler.manage" />
      ) : (
        <JobForm
          onSaved={(job) => navigate(`${SCHEDULER_BASE}/jobs/${encodeURIComponent(job.id)}`)}
          onCancel={() => navigate(`${SCHEDULER_BASE}/jobs`)}
        />
      )}
    </PageShell>
  );
};

export default SchedulerJobFormPage;
